<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">Detalle de contrato {{loan.contractNumber}}</h4>
    <button type="button" class="close" (click)="this.bsModalRef.hide()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <accordion [isAnimated]="true">
      <accordion-group [isOpen]="true" *ngFor="let invoice of loan!.invoices">
        <span accordion-heading>
          <i class="fa fa-regular fa-file-lines"></i> {{getHeaderText(invoice)}}
          <b>{{ invoice!.invoiceCode || invoice!.receiptCode }}</b>
        </span>
        <pos-table [tableFormId]="'invoiceTable'+loan.contractNumber" [data]="invoice.pagingInvoiceLines"
          [headers]="getInvoiceHeaders()" [itemsPerPage]="10" [pagination]="false"></pos-table>
      </accordion-group>
      <accordion-group [isOpen]="true">
        <span accordion-heading>
          <i class="fa fa-regular fa-file-lines"></i> Recibos de Recaudo
        </span>
        <pos-table [tableFormId]="'recieptTable'+loan.contractNumber" [data]="recollectionReceipts"
          [headers]="getReceiptHeaders()" [itemsPerPage]="10" [pagination]="true" [disableHighlight]="true"
          (dataChange)="getData($event)" (rowClick)="printReceipt($event)"></pos-table>
      </accordion-group>
    </accordion>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="this.bsModalRef.hide()">
      Aceptar
    </button>
  </div>
</div>